import React from "react"
import css from "./CheckBox.scss"
import PropTypes from "prop-types"
const CheckBox = ({ child, isSelected, isDisabled, value, onClick, alignCenter }) => {
    const handleChange = () => {
        if (!isDisabled) {
            onClick(value)
        }
    }
    return (
        <div className={`flex ${alignCenter ? "alignCenter" : ""}`} onClick={() => handleChange()}>
            <input
                className={`${css.checkboxInput} ${isDisabled ? css.disabledInput : ""} textAction`}
                type={"checkbox"}
                disabled={isDisabled}
                checked={isSelected}
            />
            {child}
        </div>
    )
}

CheckBox.propTypes = {
    child: PropTypes.node,
    isSelected: PropTypes.bool,
    value: PropTypes.any,
    onClick: PropTypes.func,
    isDisabled: PropTypes.bool,
    alignCenter: PropTypes.bool,
}

export default CheckBox
